import { useQuery } from "@tanstack/react-query";

import { useSession } from "../auth/hooks";

import { getMyActivityStats, getMyRecentActivity } from "./api";

export function useMyActivityStats() {
  const { user } = useSession();
  return useQuery({
    queryKey: ["activity", "stats", user?.id ?? ""],
    queryFn: () => getMyActivityStats(user!.id),
    enabled: !!user?.id,
    staleTime: 30_000,
  });
}

export function useMyRecentActivity() {
  const { user } = useSession();
  return useQuery({
    queryKey: ["activity", "recent", user?.id ?? ""],
    queryFn: () => getMyRecentActivity(user!.id),
    enabled: !!user?.id,
    staleTime: 30_000,
  });
}
